import { AfterViewInit, Component, OnDestroy, inject } from '@angular/core';
import { GameSearchService } from '../../../../services/games/game-search.service';
import { GameFilterService } from '../../../../services/games/game-filter.service';
import { debounceTime, filter } from 'rxjs/operators';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { NgClass } from '@angular/common';
import { FormInputComponent } from '../../../components/form-controls/form-input/form-input.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-games-search',
    templateUrl: './games-search.component.html',
    styleUrls: ['./games-search.component.scss'],
    imports: [ReactiveFormsModule, FormInputComponent, NgClass, TranslatePipe]
})
export class GamesSearchComponent implements AfterViewInit, OnDestroy {
  gamesSearch = inject(GameSearchService);
  private _gamesFilters = inject(GameFilterService);


  ngOnDestroy() {
    this.gamesSearch.searchForm.reset();
  }

  ngAfterViewInit() {
    this.gamesSearch.handleInput();
    this.gamesSearch.searchForm.valueChanges
      .pipe(
        debounceTime(500),
        filter(() => !!this.gamesSearch.searchStr && !this.gamesSearch.showPopup),
      )
      .subscribe(() => {
        this.applySearchFilter();
      });
  }

  applySearchFilter() {
    this._gamesFilters
      .applyFilters({
        search: this.gamesSearch.searchStr,
      })
      .then(() => {
        this.gamesSearch.showPopup = false;
        this.gamesSearch.onClose();
      });
  }
}
